// extracted by mini-css-extract-plugin
export default {"container":"ProductSelector_container__8Kx1k"};